import React, { useState } from "react";
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import { TextButton } from "../components/commonComponents/Buttons/ActionButton";
import { Download } from "@mui/icons-material";

// Utility: Move item up/down in an array
const moveItem = (arr, fromIndex, toIndex) => {
  if (toIndex < 0 || toIndex >= arr.length) return arr;
  const newArr = [...arr];
  const [moved] = newArr.splice(fromIndex, 1);
  newArr.splice(toIndex, 0, moved);
  return newArr;
};

export default function CustomDualListExample() {
  // Static options
  const options = [
    { value: "apple", label: "Apple" },
    { value: "banana", label: "Banana" },
    { value: "cherry", label: "Cherry" },
    { value: "date", label: "Date" },
    { value: "grape", label: "Grape" },
  ];

  // Left "selected" list (sortable)
  const [leftSelections, setLeftSelections] = useState([
    { value: "apple", label: "🍎 Apple" },
    { value: "banana", label: "🍌 Banana" },
  ]);

  // Right "selected" list (managed by DualListbox)
  const [rightSelections, setRightSelections] = useState(["cherry"]);

  // Handle DualListbox changes
  const handleRightChange = (selected) => {
    setRightSelections(selected);
  };

  return (
    <div style={{ display: "flex", gap: "20px" }}>
      {/* Left Box: custom rendering + sorting */}
      <div
        style={{
          flex: 1,
          border: "1px solid #ccc",
          padding: "10px",
          borderRadius: "6px",
        }}
      >
        <h4>Left Box (also selected)</h4>
        {leftSelections.map((item, index) => (
          <div
            key={item.value}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "6px",
              background: "#f9f9f9",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            <span>{item.label}</span>
            <div style={{ display: "flex", gap: "4px" }}>
              <button
                onClick={() =>
                  setLeftSelections((prev) => moveItem(prev, index, index - 1))
                }
              >
                ⬆️
              </button>
              <button
                onClick={() =>
                  setLeftSelections((prev) => moveItem(prev, index, index + 1))
                }
              >
                ⬇️
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Right Box: handled by react-dual-listbox */}
      <div style={{ flex: 1 }}>
        <h4>Right Box (saved in Redux later)</h4>
        <DualListBox
          options={options}
          selected={rightSelections}
          onChange={handleRightChange}
          canFilter
        />
      </div>
      
    </div>
  );
}
